<script lang="ts" setup>
import { AlgoliaDropdownsOptionsProps } from "./AlgoliaDropdownsOptions.props"

const props = defineProps<AlgoliaDropdownsOptionsProps>()
const emit =
  defineEmits<{
    (e: "onToggle", value: boolean): void
    (e: "onDelete"): void
    (e: "onApply"): void
  }>()

const defaultContentClass = `p-4 ${props.contentClass}`

const finalContentClass = computed(
  () => props?.contentClass ?? defaultContentClass
)

const closeDropdown = (resetOptions: any) => {
  emit("onToggle", resetOptions)
}

const { event, sendEvent } = useGAEvent(
  `track_select_content_${props.name}_`,
  "custom_event"
)

const onClickedFilter = (filter: { label: string }, category: string) => {
  event.value = {
    event: "select_content",
    action: "filter",
    category: category.toLowerCase(),
    label: filter.label
  }
  sendEvent({ clearEcommerce: false })
}
</script>

<template>
  <FiltersUtilsDropdown
    :content-class="finalContentClass"
    :text="text"
    :opened="opened"
    :facet-name="facetName"
    @onToggle="closeDropdown"
    @onApply="emit('onApply')"
    @on-delete="emit('onDelete')"
  >
    <AisRefinementList :attribute="facetName" searchable :limit="20">
      <template v-slot="{ items, refine, searchForItems }">
        <TextfieldsSearch
          :name="`brands-search`"
          :label="searchPlaceholder"
          :placeholder="searchPlaceholder"
          show-icon-left
          @update:model-value="searchForItems"
        />
        <div
          class="
            scrollbar
            mt-2
            max-h-[13.5rem]
            overflow-y-auto
            overscroll-y-none
          "
        >
          <FiltersUtilsOption
            v-for="(item, index) of items"
            :key="`filter-option-${index}`"
            :name="item.value"
            :checked="item.isRefined"
            @clicked="
              () => {
                onClickedFilter(item, text)
                refine(item.value)
              }
            "
            :text="item.label"
            :n-results="item.count"
          />
        </div>
      </template>
    </AisRefinementList>
  </FiltersUtilsDropdown>
</template>

<style lang="scss" scoped>

.scrollbar {
  --scrollbar-color: #b2b2b2;
  --scrollbar-width: 0.4375rem;

  scrollbar-color: var(--scrollbar-color) white;
  scrollbar-width: var(--scrollbar-width);

  &::-webkit-scrollbar {
    @apply w-[var(--scrollbar-width)];
  }

  &::-webkit-scrollbar-thumb {
    @apply rounded-full bg-[var(--scrollbar-color)];
  }
}

</style>
